import { Metadata } from 'next';
import TermDetailClient from './client';

export const metadata: Metadata = {
    title: '약관 상세 - InsuWiki Admin',
    description: '보험 약관 3단계 요약 상세 보기',
};

export default function InsuranceTermDetailPage() {
    return (
        <div className="min-h-screen bg-slate-50">
            <div className="max-w-4xl mx-auto px-4 py-8">
                <TermDetailClient />
            </div>
        </div>
    );
}
